import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .get("user", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    workingGroupUsers(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .get("workingGroupUsers")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    /********* Roles */
    /*********** */
    fetchRoles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("roles", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    fetchPermissions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("permissions", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    addRole(ctx, role) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("roles/store", role)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    updateRole(payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`roles/${payload.role}`, payload.permissions)
          .then((response) => {
            resolve(response);
            //    showToast("success");
          })
          .catch((error) => reject(error));
      });
    },

    // DEPARTMENT

    getAllCompanies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("getCompany", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getCompanyById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getCompanyById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateCompany(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateCompany/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteCompany(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteCompany/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    saveCompany(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveCompany", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Pillar

    savePillar(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("savePillar", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkOrderNumber(ctx, order) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`checkPillarOrderNumber`, { order })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllPillars(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("pillars")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getPillarById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getPillarById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updatePillar(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updatePillar/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deletePillar(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deletePillar/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //pillar title

    savePillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("savePillarTitle", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllPillarTitles(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("pillarTitles")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getPillarTitleById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getPillarTitleById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updatePillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updatePillarTitle/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusPillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusPillarTitle/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deletePillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deletePillarTitle/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkPillarTitleUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkPillarTitleUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Objective

    saveObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveObjective", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllObjectives(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("objectives")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getObjectiveById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getObjectiveById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateObjective/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusObjective/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteObjective/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkObjectiveUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkObjectiveUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Action

    saveAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveAction", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllActions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("actions")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getActionById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getActionById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateAction/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusAction/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteAction/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkActionUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkActionUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //KPI

    saveKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveKPI", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllKPIs(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("kpis")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getKPIById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getKPIById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateKPI/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusKPI/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteKPI/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkKPIUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkKPIUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Narrative

    saveNarrative(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveNarrative", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllNarratives(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("narratives")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getNarrativeById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getNarrativeById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateNarrative(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateNarrative/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteNarrative(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteNarrative/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //CSF

    saveCSF(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveCSF", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllCSFs(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("csfs")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getCSFById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getCSFById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateCSF(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateCSF/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteCSF(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteCSF/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Owner

    saveOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveOwner", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllOwners(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("owners")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getOwnerById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getOwnerById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateOwner/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusOwner/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteOwner/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkOwnerUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkOwnerUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Priority

    savePriority(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("savePriority", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllPriorities(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("priorities")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getPriorityById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getPriorityById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updatePriority(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updatePriority/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deletePriority(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deletePriority/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Working Group

    saveWorkingGroup(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveWorkingGroup", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllWorkingGroups(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("workingGroups")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getWorkingGroupById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateWorkingGroup(ctx, metData) {
      const id = metData instanceof FormData ? metData.get("id") : metData.id;
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`updateWorkingGroup/${id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusWorkingGroup(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusWorkingGroup/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteWorkingGroup(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteWorkingGroup/${metData.id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    checkWorkingGroupUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkWorkingGroupUsage/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupToolSubsections(ctx, wg_id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/workingGroupTools/subsection-inputs/${wg_id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // Timeline Actions
    getAllTimelineActions(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getAllTimelineActions", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    getWgOwnerOptions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getWgOwnerOptions")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    removeWorkingGroupDocument(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`workingGroup/removeWorkingGroupDocument/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
